export const ERROR_EN_REGISTRO = 'ERROR EN REGISTRO ';
export const ERROR_AL_TRAER_LOS_PRODUCTOS = 'ERROR AL TRAER LOS PRODUCTOS';
export const ERROR_EN_CONSULTAR_CODIGO_PROMOCIONALES = 'ERROR EN CONSULTAR CODIGO PROMOCIONALES';
export const ERROR_AL_OBTENER_DATOS_DE_CARTERA = 'ERROR AL OBTENER DATOS DE CARTERA';
export const ERROR_AL_AGREGAR_INFORMACION_ADICIONAL = 'ERROR AL AGREGAR INFORMACION ADICIONAL';
export const ERROR_AL_VALIDAR_LOS_DATOS_DEL_CLIENTE = 'ERROR AL VALIDAR LOS DATOS DEL CLIENTE';
export const ERROR_EN_OTP = 'ERROR EN OTP';
export const ERROR_AL_AGREGAR_INTERVINIENTE = 'ERROR AL AGREGAR INTERVINIENTE';
export const ERROR_AL_ELIMINAR_INTERVINIENTE = 'ERROR AL ELIMINAR INTERVINIENTE';
export const ERROR_AL_EDITAR_INTERVINIENTE = 'ERROR AL EDITAR INTERVINIENTE';
export const ERROR_AL_ENVIAR_INVITACION = 'ERROR AL ENVIAR INVITACION';
export const ERROR_AL_CONFIGURAR_TARJETA_DE_CREDITO = 'ERROR AL CONFIGURAR TARJETA DE CREDITO';
export const ERROR_AL_CONFIGURAR_TARJETA_DE_DEBITO = 'ERROR AL CONFIGURAR TARJETA DE DEBITO';
export const ERROR_AL_ACTUALIZAR_TARJETA_DEBITO = 'ERROR AL ACTUALIZAR TARJETA DEBITO';
export const ERROR_CASO_EMPLEADO = 'ERROR CASO EMPLEADO';
export const ERROR_CASO_CUENTA_PROPIA = 'ERROR CASO CUENTA PROPIA';
export const ERROR_CASO_PENSIONISTA = 'ERROR CASO PENSIONISTA';
export const ERROR_CASO_CUENTA_AJENA = 'ERROR CASO CUENTA AJENA';
export const ERROR_CASO_DESEMPLEADO = 'ERROR CASO DESEMPLEADO';
export const ERROR_AL_VERIFICAR_FIOC = 'ERROR AL VERIFICAR FIOC';
export const ERROR_EN_STAND_BY_INTERMEDIO_AL_TRAER_DATOS_INTERV = 'ERROR EN STAND BY INTERMEDIO AL TRAER DATOS INTERV';
export const ERROR_EN_IDENTIFICACION = 'ERROR EN IDENTIFICACION';
export const ERROR_CASO_IBAN = 'ERROR CASO IBAN';
export const ERROR_CASO_TRANSFERENCIA = 'ERROR CASO TRANSFERENCIA';
export const ERROR_CASO_VIDEOLLAMADA = 'ERROR CASO VIDEOLLAMADA';
export const ERROR_CASO_VIDEOSELFIE = 'ERROR CASO VIDEOSELFIE';
export const ERROR_CASO_EN_OFICINA = 'ERROR CASO EN OFICINA';
export const ERROR_CASO_EN_DOMICILIO = 'ERROR CASO EN DOMICILIO';
export const ERROR_AL_ENVIAR_CONTENIDO_GDPR = 'ERROR AL ENVIAR CONTENIDO GDPR';
export const ERROR_AL_CREAR_EL_CONTRATO = 'ERROR AL CREAR EL CONTRATO';
export const ERROR_EN_DOCUMENTACION = 'ERROR EN DOCUMENTACION';
export const ERROR_AL_CONFIRMAR_DOCUMENTACION = 'ERROR AL CONFIRMAR DOCUMENTACION';
export const ERROR_AL_SUBIR_DOCUMENTACION = 'ERROR AL SUBIR DOCUMENTACION';
export const ERROR_AL_REGISTRARSE_UN_INTERVINIENTE = 'ERROR AL REGISTRARSE UN INTERVINIENTE';
export const ERROR_AL_VALIDAR_IBAN_FORMATO = 'error iban incorrecto / formato';
export const ERROR_AL_VALIDAR_IBAN_ENTIDAD = 'error iban incorrecto / validacion por entidad bancaria ';
export const ERROR_IBAN_INPUT = 'error-input';
export const ERROR_IBAN_SERVICIO = 'error-servicio';
export const ERROR_DOSSIER = 'ERROR AL TRAER EL DOSSIER';
export const ERROR_AL_RECUPERAR_ONBOARDING = 'ERROR AL RECUPERAR ONBOARDING';
export const ERROR_AL_ENVIAR_SIMULACION = 'ERROR AL ENVIAR SIMULACION';
export const ERROR_AL_CREAR_CLIENTE = 'ERROR AL CREAR CLIENTE';
export const ERROR_CAPTCHA = 'ERROR CAPTCHA';
export const ERROR_AL_VERIFICAR_CLIENTE = 'ERROR AL VERIFICAR CLIENTE';
export const ERROR_AL_ENVIAR_DATOS_PERSONALES = 'ERROR AL ENVIAR DATOS PERSONALES';
export const ERROR_AL_FIRMAR_CONTRATO_LOGALTY = 'ERROR AL FIRMAR CONTRATO LOGALTY';
export const ERROR_AL_OBTENER_IMPLEMENTACION_CONTRATO = 'ERROR AL OBTENER IMPLEMENTACION CONTRATO';
export const ERROR_AL_EVIAR_RECHAZO_GBI = 'ERROR AL EVIAR RECHAZO GBI';
export const ERROR_AL_EVIAR_RECHAZO_ROBO = 'ERROR AL EVIAR RECHAZO ROBO';
export const ERROR_TEST_IDONEIDAD = 'ERROR TEST IDONEIDAD';
export const ERROR_AL_OBTENER_VISTA_DE_PASO = 'ERROR AL OBTENER VISTA DEL PASO';
export const ERROR_OPEN_SINGNING_CONTRACT_STATE = 'ERROR POLLING ABIERTO ESTADO FIRMA CONTRATO';
